import React from 'react';

import PartnerSlider from './PartnerSlider/PartnerSlider';
import { partnerLogosData1, partnerLogosData2, partnerLogosData3, partnerLogosData4, partnerLogosData5, PartnerHeading } from '../../config';
import { BusinessWrapper } from './BusinessPartnersStyles';

const BusinessPartners = () => (
	<BusinessWrapper id='BusinessPartners'>
		<PartnerSlider
			logos={[partnerLogosData1, partnerLogosData2, partnerLogosData3, partnerLogosData4, partnerLogosData5]}
			heading={PartnerHeading}
		/>
	</BusinessWrapper>
);

export default BusinessPartners;
